import { ReactElement, useMemo } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonProcessingJobCrumbs } from '../constants';
import FormFunction, { ProcessingJobForm } from 'system/components/processing-job/form';
import { noop } from 'shell/utils/noop';
import { useParams, useNavigate } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { __OPERATION__BATCH__ } from 'shell/constants/environment';
import { DetailProcessingJobType } from 'shell/models/job-execution';
import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { HttpResponse } from 'shell/models/http-response';

const ProcessingJobDetail = (): ReactElement => {
  const navigate = useNavigate();
  const params = useParams();

  const [processingJob] = useHttpFetch<HttpResponse<DetailProcessingJobType>, ProcessingJobForm>(
    `${__OPERATION__BATCH__}/executions/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: [],
      },
      transformer: (response: AxiosResponse<HttpResponse<DetailProcessingJobType>>) => {
        const data: DetailProcessingJobType = response.data.payload || {};

        const res: ProcessingJobForm = {
          id: data?.id.toString(),
          description: data?.jobName,
          from: data?.startedAt ? DateTime.fromISO(data?.startedAt) : null,
          to: data?.completedAt ? DateTime.fromISO(data?.completedAt) : null,
          state: data?.status,
          sent: data?.startedAt ? DateTime.fromISO(data?.startedAt) : null,
          numError:
            data?.outputParameters?.find((job) => job.name === 'ERRORS')?.value || undefined,
          numInput:
            data?.outputParameters?.find((job) => job.name === 'INPUTS')?.value || undefined,
          numOutput:
            data?.outputParameters?.find((job) => job.name === 'OUTPUTS')?.value || undefined,
          reason: '',
          numWarning:
            data?.outputParameters?.find((job) => job.name === 'WARNINGS')?.value || undefined,
        };
        return res;
      },
    }
  );

  const content = useMemo(() => {
    return processingJob.pristine || processingJob.isLoading || processingJob.hasErrors ? null : (
      <FormFunction
        title="Dettaglio Elaborazione Job"
        onOk={noop}
        onCancel={() => {
          navigate('/sistema/elaborazione-job');
        }}
        disabled
        initialValues={processingJob.data as ProcessingJobForm}
      />
    );
  }, [processingJob, navigate]);

  return (
    <>
      <Breadcrumbs items={[...CommonProcessingJobCrumbs, { name: 'Dettaglio Elaborazione Job' }]} />
      {content}
    </>
  );
};

ProcessingJobDetail.displayName = 'ProcessingJob Detail';

export default ProcessingJobDetail;
